<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<br/><br/><br/><br/>
<p class="noindent">© 2011 Karen “Enjil” Hudson Washington</p>
<p class="noindent1">All rights reserved. No part of this book may be used or reproduced in any manner without written permission except in the case of brief quotations embodied in critical articles or reviews.</p>
<p class="noindent1">This is a work of fiction. Any similarity to real persons, living or dead, is coincidental and not intended by the author.</p>
<p class="noindent1">Treacherous: The Beginning</p>
<p class="noindent1">Brown Books Small Press</p>
<p class="noindent">16200 North Dallas Parkway, Suite 170</p>
<p class="noindent">Dallas, Texas 75248</p>
<p class="noindent"><a href="http://www.BrownBooksSmallPress.com" target="_blank">www.BrownBooksSmallPress.com</a></p>
<p class="noindent">(972) 381-0009</p>
<p class="noindent1">A New Era in Publishing™</p>
<p class="noindent1">eISBN: 978-1-61254-773-2</p>
<p class="noindent">Library of Congress Control Number 2011920496</p>
<p class="noindent1">Printing in the United States.</p>
<p class="noindent">10 9 8 7 6 5 4 3 2 1</p>
<p class="noindent1">For more information or questions please</p>
<p class="noindent">email the author at <a href="mailto:TreacherousTheBook@yahoo.com">TreacherousTheBook@yahoo.com</a></p>
<p class="noindent">or visit: <a href="http://www.TreacheroustheBook.com" target="_blank">www.TreacheroustheBook.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?cc67d30a